import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class TeamOfExperts extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get experts() {
    return get(this, '_pracownik.value', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/TeamOfExperts.model.js